/**
 * Where ThreadFlow will ship -- the browser-side mirror of the server's
 * ship-to country allow-list (api/src/shipping/country_policy.py).
 *
 * MVP LAUNCH CONSTRAINT, NOT A PERMANENT RULE. ThreadFlow launches US-only
 * because internationalization is not built. Widen SHIPPABLE_COUNTRIES here
 * AND in the Python module when a second country ships.
 *
 * THIS IS A UX HINT, NOT THE GATE. The authoritative refusal is server-side
 * at order creation; a client cannot be trusted to enforce it. The value of
 * this copy is that the shopper learns the constraint at ADDRESS ENTRY
 * instead of after the cart has shown a $0 shipping line (the rate endpoint
 * deliberately still returns 0 for a non-US address -- issue #2882 owns what
 * a shopper sees when a rate is unavailable, which is a different question).
 */

// ISO 3166-1 alpha-2 codes we will ship to today.
export const SHIPPABLE_COUNTRIES = ["US"];

// Spellings the country picker or a saved address may carry for a shippable
// country. Mirrors the _COUNTRY_ALIASES map on the server.
const ALIASES = {
  US: "US",
  USA: "US",
  "U.S.": "US",
  "U.S.A.": "US",
  "UNITED STATES": "US",
  "UNITED STATES OF AMERICA": "US",
};

/** Normalize a country value to its ISO code, or null when unresolvable. */
export function normalizeCountry(value) {
  if (typeof value !== "string") return null;
  const raw = value.trim();
  if (!raw) return null;
  return ALIASES[raw.toUpperCase()] || null;
}

/** True when the value resolves to a country we ship to today. */
export function isShippableCountry(value) {
  const code = normalizeCountry(value);
  return code !== null && SHIPPABLE_COUNTRIES.includes(code);
}

// Shopper-facing copy. Kept verbatim in step with the server's
// UNSUPPORTED_COUNTRY_MESSAGE so the shopper sees the same sentence whether
// the browser caught it or the server refused.
export const UNSUPPORTED_COUNTRY_MESSAGE =
  "We can only ship to addresses in the United States right now. " +
  "Please enter a US shipping address.";

/**
 * Vuetify rule: true when shippable, else the refusal string.
 *
 * Empty is left to the separate required-field rule so a blank country shows
 * "required", not "we do not ship there".
 */
export function validateShippableCountry(value) {
  if (value === null || value === undefined || value === "") return true;
  return isShippableCountry(value) || UNSUPPORTED_COUNTRY_MESSAGE;
}
